import { useQuery } from "@tanstack/react-query";
import { TransferOrderService } from "src/services";
import { APIError } from "src/errors";
import { queryKeys } from "src/constants";

export const useTransferOrder = (transferOrderId: string, transferOrderService: TransferOrderService) => {
  const {
    data: transferOrder,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: queryKeys.transferOrder(transferOrderId),
    queryFn: async () => {
      try {
        return await transferOrderService.getTransferOrderById(transferOrderId);
      } catch (error) {
        if (error instanceof APIError && error.statusCode === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!transferOrderId,
    retry: false
  });

  return { transferOrder, fetchError, isLoading, refetch };
};
